<template>
  <el-main class="container">
    <Nav>
      <div class="right" slot="right">
        <!-- <el-button
          type="primary"
          style="margin-right:15px"
          @click="handleCancel">
          取消订单设置</el-button> -->
        <el-button
          v-show="hasAuthority('addMeeting')"
          type="primary"
          class="excel"
          @click="handlerPages()">
          新增会议室</el-button>
      </div>
    </Nav>
    <table-pagination
      ref="table"
      :config="config"
      :datasource="datasource"
      :idRow="true"
      :width="150"
      @change-page="handlerPageChange">
      <el-table-column
        slot="action"
        fixed="right"
        label="操作"
        width="250"
        align="center">
        <template slot-scope="scope">
          <div>
            <el-link
              v-show="hasAuthority('editMeeting')"
              type='primary'
              :underline="false"
              class="details"
              @click="handlerRouter('set', scope)">
              编辑</el-link>
            <el-link
              v-show="hasAuthority('deleteMeeting')"
              style="margin-left: 5px"
              type='primary'
              :underline="false"
              class="details"
              @click="event().deleteMeeting(scope)">
              删除</el-link>
          </div>
        </template>
      </el-table-column>
    </table-pagination>
    <el-dialog
      :visible.sync="dialogVisable"
      width="600px"
      :show-close="false"
    >
      <div class="dialog-box">
        <div class="title">取消订单设置</div>
        <div class="row">
          <div class="text">会议开始前</div><el-input class="dialog-input" v-model="inputCancelHour" type="number"></el-input><div class="text">小时可免费取消</div>
        </div>
        <div class="row">
          <div class="text">会议开始前</div>
          <el-input class="dialog-input" v-model="inputDiscountHour" type="number"></el-input>
          <div class="text">小时扣除</div>
          <el-input class="dialog-input" v-model="inputCancelPercent" type="number"></el-input>
          <div class="text">%支付金额</div>
        </div>
        <div class="btn-box">
          <el-button @click="handleCloseDialog">取消</el-button>
          <el-button type="primary" @click="handleSubmit">确认</el-button>
        </div>
      </div>
    </el-dialog>
  </el-main>
</template>

<script>
import { getMeetingList, deleteMeeting } from '@/api/meeting'
import Nav from '@/components/nav'
import TablePagination from '@/components/table-pagination'
export default {
  data() {
    return {
      body: {
        pageSize: 10,
        pageIndex: 1
      },
      config: {
        size: 10,
        fields: [
          {
            prop: 'title',
            label: '会议室名称'
          },
          {
            prop: 'picture',
            label: '封面图',
            type: 'image',
            width: '250',
            imgH: '130',
            imgW: '130'
          },
          {
            prop: 'industryName',
            label: '所属产业'
          },
          {
            prop: 'number',
            label: '可容纳人数'
          },
          {
            prop: 'area',
            label: '面积(m²)'
          },
          {
            prop: 'price',
            label: '价格(/小时)'
          }
        ]
      },
      datasource: {
        total: 0,
        data: []
      },
      dialogVisable: false,
      inputCancelHour: null,
      inputDiscountHour: null,
      inputCancelPercent: null,
    }
  },
  mounted() {
    this.network().getMeetingList()
  },
  methods: {
    event() {
      return {
        deleteMeeting: (scope) => {
          this.$confirm('是否删除该会议室？', '删除', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.network().deleteMeeting(scope.row.uuid)
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
        }
      }
    },
    network() {
      return {
        getMeetingList: async() => {
          const { data } = await getMeetingList(this.body)
          this.datasource.total = data.total
          this.datasource.data = data.list
        },
        deleteMeeting: async(uuid) => {
          await deleteMeeting(uuid)
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.network().getMeetingList()
        }
      }
    },
    handlerPageChange(data) {
      this.body.pageIndex = data.page
      this.network().getMeetingList()
    },
    handlerPages() {
      this.$router.push({ path: '/metting-management/list-management/add' })
    },
    handlerRouter(type, scope) {
      if (type === 'set') {
        this.$router.push(`/metting-management/list-management/set/${scope.row.uuid}`)
      }
    },
    handleCancel(){
      this.dialogVisable = true
    },
    handleCloseDialog(){
      this.inputDiscountHour = null
      this.inputCancelPercent = null
      this.inputCancelHour = null
      this.dialogVisable = false
    },
    handleSubmit(){

    }
  },
  components: {
    Nav,
    TablePagination
  }
}
</script>

<style scoped lang="scss">
/deep/.el-dialog{
  border-radius: 15px;
  /deep/.el-dialog__header {
    padding: 0;
  }
}

.dialog-box{
  display: flex;
  flex-direction: column;
  .title{
    display: flex;
    justify-content: center;
    font-weight: 900;
    font-size: 20px;
  }
  .row{
    display: flex;
    margin: 30px 0;
    align-items: center;
    .text{
      margin: 0 10px;
    }
    .dialog-input{
      width: 20%;
    }
  }
  .btn-box{
    display: flex;
    justify-content: center;
  }
}
</style>
